module.exports = __webpack_public_path__ + "img/vallarta.4debfd44.png";